import { FunctionComponent } from "react";
import {Typography, Grid, Container, Button} from "@mui/material";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { ImageAsset, Link as LinkType } from "../../types";
import { Document } from "@contentful/rich-text-types";
import styled from "styled-components";
import ChequeredStrip from "../blockComponents/ChequeredStrip";
import {Facebook, Twitter, Email, LinkedIn} from "@mui/icons-material";
import { useRouter } from "next/router";

import Link from "next/link";
import ArrowCircleIcon from "../icons/ArrowCicled";

interface Props {
  category: string[];
  hero: {
    featureImage: ImageAsset;
    title: string;
    content: Document;
    callToAction: LinkType;
  };
}
const StyledContainer = styled(Container)`
  z-index: 2;
  font-size: 1rem;
  img {
    margin-top: -2em;
    width: 100%;
  }
`;
const Wrapper = styled.div`
  width: 100%;
`;
const StyledButton = styled(Button)`
  && {
    font-weight: 800;
    font-size: 1.5em;
    color: #de4a22;
    .btn-text{
      margin-left:.5rem;
    }
  }
`;
const SocialIcons = styled.span`
  vertical-align: middle;
`;
const TitleWrapper = styled.div`
  width: 100%;
  background-color: #f0f0f0;
  height: 160px;
  display: flex;
`;
const FlexContainer = styled(Container)`
  && {
    display: flex;
    align-items: center;
  }
`;
const HeroBlog: FunctionComponent<Props> = ({
  hero: { featureImage, title, content, callToAction },
  category,
}) => {
  const hero = {
    image: featureImage.fields.file.url,
    imageText: featureImage.fields.title,
  };
  const description = content ? documentToReactComponents(content) : "";
  const linkText = callToAction ? callToAction.fields.linkTitle : "";
  const linkUrl = callToAction ? callToAction.fields.linkUrl : "";
  const router = useRouter();

  return (
    <Wrapper>
      <TitleWrapper>
        <ChequeredStrip location="top" />
        <FlexContainer maxWidth="lg">
          <div>
            <Link href="/blog">
              <span>
                <StyledButton variant="text">
                  <ArrowCircleIcon rotation={180}/> <span className="btn-text">Back to blog</span>
                </StyledButton>
              </span>
            </Link>
            <Typography
              component="h1"
              variant="h1"
              color="inherit"
              gutterBottom
            >
              {title}
            </Typography>
          </div>
        </FlexContainer>
      </TitleWrapper>
      <StyledContainer maxWidth="lg">
        <Grid container alignItems="center" justifyContent="center">
          <Grid item xs={12}>
            <div>{description}</div>
            {callToAction && (
              <Button variant="contained" color="primary" href={linkUrl}>
                {linkText}
              </Button>
            )}
          </Grid>
          <Grid item xs={12}>
            <img src={`${hero.image}?h=208`} alt={hero.imageText} />
          </Grid>
        </Grid>
        <Grid container alignItems="center" justifyContent="center">
          <Grid item xs={6}>
            <span>Share </span>
            <SocialIcons>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://www.emergencyserviceslawyers.com.au${router.asPath}`}
              >
                <Facebook htmlColor="#E6E6E6" fontSize="large" />
              </a>
              <a
                href={`https://www.twitter.com/intent/tweet?status=https://www.emergencyserviceslawyers.com.au${router.asPath}`}
              >
                <Twitter htmlColor="#E6E6E6" fontSize="large" />
              </a>
              <a
                href={`https://www.linkedin.com/shareArticle?mini=true&amp;url=https://www.emergencyserviceslawyers.com.au${router.asPath}`}
              >
                <LinkedIn htmlColor="#E6E6E6" fontSize="large" />
              </a>
              <a
                href={`mailto:?subject=I wanted you to see this site&amp;body=Check out this site https://www.emergencyserviceslawyers.com.au${router.asPath}`}
                title="Share by Email"
              >
                <Email htmlColor="#E6E6E6" fontSize="large" />
              </a>
            </SocialIcons>
          </Grid>
          <Grid item xs={6}>
            Topic: {category}
          </Grid>
        </Grid>
      </StyledContainer>
    </Wrapper>
  );
};
export default HeroBlog;
